/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any) => ({
  // 결제내역 조회
  async index(data?: any) {
    return camelize(await $axios.get(`/payment`, snakelize({ params: data })))
  },

  // 결제
  async proceed(data?: any) {
    return camelize(await $axios.post(`/payment`, snakelize(data)))
  },
})
